/* eslint-disable */
import { call, put, takeEvery, takeLatest } from "redux-saga/effects";

// Login Redux States
import { CHECK_AUTH, LOGIN_USER, LOGOUT_USER } from "./actionTypes";
import { apiError, loginSuccess } from "./actions";
import { login, checkAuth } from "../../../helpers/backend_helper";
import Cookies from "universal-cookie";
import { RememberMe } from "@mui/icons-material";
import { post } from "../../../helpers/api_helper";
const cookies = new Cookies();

//Include Both Helper File with needed methods

function* loginUser({ payload: { user, history } }) {
  try {
    const response = yield call(login, {
      username: user.username,
      password: user.password,
      // rememberMe:user.rememberMe
    });

    if (response.status == 200) {
      yield put(loginSuccess());
      localStorage.setItem("authUser", JSON.stringify(response.data));
      localStorage.setItem("localbodyID", response.data.branch);
      cookies.set("rememberMe", "true", { path: "/" });
      history.push("/dashboard");
      window.location.reload();
    } else {
      yield put(apiError(response.message));
    }
  } catch (error) {
    console.log(error, "******");
    yield put(apiError(error.response));
  }
}

function* checkAuthentication({ payload: history }) {
  try {
    let adminData = JSON.parse(localStorage.getItem("authUser"));
    const response = yield call(checkAuth, {
      token: adminData.token,
    });
    history.push("/dashboard");
  } catch (error) {
    // console.log(error, "errro");
    localStorage.removeItem("authUser");
    history.push("/login");
  }
}

function* logoutUser({ payload: { history } }) {
  try {
    localStorage.removeItem("authUser");
    post("login/remove");
    history.push("/login");
  } catch (error) {
    yield put(apiError(error));
  }
}

function* authSaga() {
  yield takeEvery(LOGIN_USER, loginUser);
  yield takeEvery(LOGOUT_USER, logoutUser);
  yield takeEvery(CHECK_AUTH, checkAuthentication);
}

export default authSaga;
